import { JsonEditor, Select, TextField } from 'src/ui/formik'
import { Field } from 'formik'
import React from 'react'
import { StringSwitchField } from 'src/ui/formik/styled-fields'

type ConfigurationPanelFormFieldProps = Readonly<{
  config: TenantConfiguration
  index: number
  fieldPathPrefix?: string
}>

function SelectField({ id, options }: Readonly<{ id: string; options: string[] }>) {
  return (
    <Field
      id={id}
      name={id}
      component={Select}
      formControlProps={{
        height: 'unset',
        mb: null,
        width: '100%',
      }}
      type="number"
      options={options.map((opt) => ({
        value: opt,
        label: opt,
      }))}
    />
  )
}

function ToggleField({ id }: Readonly<{ id: string }>) {
  return (
    <Field
      id={id}
      name={id}
      component={StringSwitchField}
      formControlProps={{
        height: 'unset',
        mb: null,
        width: '100%',
        justifyContent: 'start',
      }}
    />
  )
}

function InputField({ id, dataType }: Readonly<{ id: string; dataType: string }>) {
  return (
    <Field
      id={id}
      name={id}
      component={TextField}
      type={dataType === 'int' || dataType === 'bigint' ? 'number' : 'text'}
      formControlProps={{
        height: 'unset',
        mb: null,
        width: '100%',
      }}
    />
  )
}

function JsonField({ id }: Readonly<{ id: string }>) {
  return <Field id={id} name={id} component={JsonEditor} height={300} />
}

export default function ConfigurationPanelFormField({
  config,
  index,
  fieldPathPrefix = 'fields',
}: ConfigurationPanelFormFieldProps) {
  const id = `${fieldPathPrefix}.${config.group}.${index}.value`
  if (config.options && config.options.length > 0) {
    return <SelectField id={id} options={config.options} />
  }

  if (config.dataType.toLowerCase() === 'boolean') {
    return <ToggleField id={id} />
  }

  if (config.dataType.toLowerCase() === 'json') {
    return <JsonField id={id} />
  }

  return <InputField id={id} dataType={config.dataType.toLowerCase()} />
}
